/** Define at which statge user authentication process is happening */
export enum AuthentictaionState {
  /** Not defined, can be before login or after logout */
  Unknown = 'unknown',
  /** Trying to authenticata user, can fail */
  Pendind = 'pending',
  /** Authenticated, and profile loaded */
  Authenticated = 'authenticated',
  /** Error during authentication process */
  Failed = 'failed',
}
